import { Button, Col, Form, Row} from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select"

export default function BillExternalForm({
        state, handleInputChange, handleCheckboxChange, handleSelectChange,
        submit, isAddingOrEditing, isRegistering, handleDeleteBillExternals, businesses}) {

    const { t } = useTranslation()

    return (
        <Form  onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.billExternals.business')}</Form.Label>
                    {isAddingOrEditing === 'adding'
                    ?
                        <Select
                            className="sd-input"
                            name='business'
                            value={state?.business ? {value: state?.business, label: businesses?.find(business => business._id === state?.business)?.name} : ''}
                            onChange={(e) => handleSelectChange(e, 'business')}
                            options={[
                                ...(businesses?.map(business => ({value: business._id, label: business.name})) || [])
                            ]}
                            required
                        />
                    :
                        <h4>{businesses?.find(business => business._id === state?.business)?.name}</h4>
                    }
                </Col>
                <Col xs={12} md={3} className="my-2">
                    <Form.Label>{t('admin.billExternals.number')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='number'
                        name='number'
                        value={state.number || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={3} className="my-2">
                    <Form.Label>{t('admin.billExternals.date')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='date'
                        name='date'
                        value={state.date ? new Date(state.date).toISOString().split('T')[0] : ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={8} className="my-2">
                    <Form.Label>{t('admin.billExternals.concept')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='concept'
                        value={state.concept || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={4} className="my-2">
                    <Form.Label>{t('admin.billExternals.quantity')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='number'
                        name='quantity'
                        value={state.quantity || 0}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} className="my-2">
                    <Form.Label>{t('admin.billExternals.accounted')}</Form.Label>
                    <Form.Check
                        className="sd-input"
                        type='checkbox'
                        name='accounted'
                        checked={state.accounted || false}
                        onChange={handleCheckboxChange}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={5} className="my-2 ms-auto">
                    <Button variant='primary' type="submit" className="w-100 my-2">
                    {isRegistering
                        ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                        :
                            isAddingOrEditing === 'editing'
                            ?
                                <>{t('global.edit')}</>
                            :
                                <>{t('global.register')}</>
                    }
                    </Button>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="fourth" className="w-100 my-2 cursor" onClick={(e) => handleDeleteBillExternals(e, state?.id)}>
                            {t('global.delete')}
                        </Button>
                    )}
                </Col>
            </Row>
        </Form>
    )
}